import { render, staticRenderFns } from "./HseHandbookIndex.vue?vue&type=template&id=319620a6&scoped=true&"
import script from "./HseHandbookIndex.vue?vue&type=script&lang=ts&"
export * from "./HseHandbookIndex.vue?vue&type=script&lang=ts&"
import style0 from "./HseHandbookIndex.vue?vue&type=style&index=0&id=319620a6&lang=scss&scoped=true&"
import style1 from "./HseHandbookIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319620a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VCard,VContent})
